import { Endpoints } from './endpoints/endpoints.interface';

export type EnvironmentName = 'prod' | 'dev' | 'qa' | 'sandbox' | 'uat';

export interface B2CPolicies {
  names: {
    signUpSignIn: string;
    editProfile: string;
  };
  authorities: {
    signUpSignIn: {
      authority: string;
    };
    editProfile: {
      authority: string;
    };
  };
  authorityDomain: string;
}
export interface Scopes {
  read: string;
}
export interface AnalyticsEnvironmentConfig {
  scripts: {
    launch: {
      src: string;
    };
  };
}
export interface EnvironmentRef {
  production: boolean;
  env: EnvironmentName;
  azureMapsApiKey: string;
  baseUrl: string;
  endpoints: Endpoints;
  b2cPolicies: B2CPolicies;
  clientId: string;
  scope: Scopes;
  aemBaseUrl: string;
  requestServiceUrl: string;
  buyPartsUrl: string;
  manageFinancingUrl: string;
  openContactFormUrl: string;
  requestServiceEquipmentDetails: string;
  warrantyPromoBannerUrl: string;
  buyPartsPromoBannerUrl: string;
  shopDeliveryAddressUrl: string;
  analytics: AnalyticsEnvironmentConfig;
  appWalkmeUrl: string;
  zendeskChatbotUrl: string;
  myInsightsPortalUrl: string;
  ecomBaseUrl: string;
}
